import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { Box, Paper, Stack, Grid, styled } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import {
  getEvaluationTemplateById,
  EvaluationTamplateDTO,
  createEvaluationdFeedback,
  EvaluationFeedbackDTO,
  postReshareForEvaluation,
  postEvaluationTemplateList,
  IInterviewerEvaluate,
  IInterviewerEvaluateName,
  getEvaluationTemplateByJobId,
  getJobByJobCode,
  postEvaluatedLink,
  getEvaluationResponseByInvitationId,
  getJobCandidateInteraction,
  updateCandidateSubmission,
} from 'wisestep-api';
import {
  Item,
  WsButton,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
  getDateUsingFormat,
  WsIconText,
  formattedDateISO,
} from 'wisestep-base';

import SurveyFeedComponent from '../../../components/SurveyBuilder/SurveyFeedComponent';
import jobCandidateInteraction from '../../../components/UpdateStatusModal/payload';
import { useUserContext } from '../../../context/index';
import { success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

import AddEditAssociate from './AssociateDialog';
import ShareCandidate from './ShareCandidate';
import SubmissionCandidateEvalutationView from './SubmissionCandidateEvalutationView';

const GridItem = styled(Item)(() => ({
  padding: '0 0 10px 0',
}));

interface ISubmissionCandiateReview {
  candidiateId?: string | null;
  candidiateData?: any;
  currentJobCode?: string | null;
  templateId?: string | null;
  flag?: boolean;
}

export const evaluationFeedbackDTOHelper: EvaluationFeedbackDTO = {
  id: '',
  workspaceId: '',
  createdBy: '',
  createdOn: '',
  updated_on: '',
  template: '',
  updatedBy: '',
  templateId: '',
  candidateId: '',
  workAssignmentId: '',
  answeredBy: '',
  invitationId: '',
  jobId: '',
  name: '',
  feedbackOption: '',
  feedbackStag: '',
  feedbackStatus: '',
};

export const interViewerPayloadHelper: IInterviewerEvaluate = {
  subject: '',
  body: '',
  interactionId: '',
  jobId: '',
  evalTemplateId: '',
  reshareEmailId: '',
};

export const interViewerNamePayloadHelper: IInterviewerEvaluateName = {
  inviteId: '',
  email: '',
  feedbackGivenBy: '',
  feedbackGivenByName: '',
};

const SubmissionCandidateReview: FC<ISubmissionCandiateReview> = ({
  candidiateId,
  currentJobCode,
  templateId,
  candidiateData,
  flag,
}) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [evaluationData, setEvaluationData] = useState<EvaluationTamplateDTO[]>([]);
  const [showSurvey, setShowSurvey] = useState(false);
  const [showFinalFeedBack, setShowFinalFeedBack] = useState(false);

  const [showTemplateList, setShowTemplateList] = useState(true);
  const [getTemplateId, setTemplateId] = useState<string>('');
  const [getInvitationId, setInvitationId] = useState<string>('');
  const [isAdminGivenFeedback, setAdminGivenFeedback] = useState<boolean>(false);
  const [getFeedbackBy, setFeedbackBy] = useState<string>('');
  const [getNameFeedbackBy, setNameFeedbackBy] = useState<string>('');
  const [getInterviwerEmail, setInterviwerEmail] = useState<string>('');
  const [getJobId, setJobId] = useState<string>('');
  const [templateJsonObject, setTemplateJsonObject] = useState<any>('');
  const [associatedJsonObject, setAssociatedJsonObject] = useState<any>('');
  const [getInterviewList, setInterviewList] = useState<any>('');
  const [getTemplateIndex, setTemplateIndex] = useState<any>('');
  const [showViewFeedback, setShowViewFeedback] = useState<boolean>(false);
  const [getFeedbackData, setFeedbackData] = useState<any>('');
  const [showAddFeedback, setShowAddFeedback] = useState<boolean>(true);
  const [isAdminFeedback, setIsAdminFeedback] = useState<boolean>(false);
  const [getAdminInvitationId, setAdminInvitationId] = useState<string>('');
  const [adminFeedbackOn, setAdminFeedbackOn] = useState<any>('');
  const [adminFeedBy, setAdminFeedBy] = useState<any>('');
  const [adminFeedByName, setAdminFeedByName] = useState<any>('');
  const [shareCandidate, setShareCandidate] = useState<boolean>(false);
  // const [candidateInfo, setCandidate] = useState<ICandidate | null>(candidiateData);

  const loggedInUser = useUserContext().userDTO ?? null;

  const [getSurveyFeedbackPayload, setSurveyFeedbackPayload] = useState<any>('');

  let adminInvitationId: string;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const jobId = await getJobByJobCode(currentJobCode as string);
        setJobId(jobId.data.id);
        const response = await getEvaluationTemplateByJobId(jobId.data.id as string);

        setEvaluationData(response.data);
        if (flag) {
          const index = response.data.findIndex((object) => {
            return (object.templateId = templateId);
          });
          setShowTemplateList(false);
          showSharedInterviwerList(Number(index), response.data, jobId.data.id);
        }
      } catch (error) {
        console.error('Error fetching evaluation data:', error);
      }
    };

    fetchData();
  }, [currentJobCode, flag, templateId]);

  useEffect(() => {
    if (!shareCandidate) {
      setShowTemplateList(true);
    }
  }, [shareCandidate]);

  useEffect(() => {
    (async () => {
      if (candidiateData?.id) {
        const interactionRecord = await getJobCandidateInteraction(candidiateData?.id);
        interactionRecord && setOtherDocument(interactionRecord.data.otherDocuments);
        candidiateData.otherDocuments = interactionRecord.data.otherDocuments;
      }
    })();
  }, [candidiateData, candidiateData?.id]);

  const giveFeedBack = (index: number) => {
    setFeedbackBy(loggedInUser?.email as string);
    setNameFeedbackBy(loggedInUser?.lastName as string);
    setInterviwerEmail(getInterviewList[index].email);
    setInvitationId(getInterviewList[index].inviteId);
    setIsAdminFeedback(false);
    setShowAddFeedback(false);
    setShowViewFeedback(false);
    setShowSurvey(true);
  };
  const viewFeedBack = async (inviteId: string) => {
    const feedbackRes = await getEvaluationResponseByInvitationId(inviteId);
    resultViewFeedback(feedbackRes.data.template);
    setShowSurvey(false);
    setShowAddFeedback(false);
    setShowViewFeedback(true);
  };

  const resultViewFeedback = (templateData: any) => {
    const keys = Object.keys(templateData);
    const feedbackArray = keys.map((ques) => ({
      ques,
      ans: templateData[ques],
    }));
    setFeedbackData(feedbackArray);
  };

  const callSendReminder = async (email: string) => {
    const payload = { ...interViewerPayloadHelper };
    payload.evalTemplateId = getTemplateId;
    payload.interactionId = candidiateId as string;
    payload.jobId = getJobId;
    payload.reshareEmailId = email;

    try {
      await postReshareForEvaluation(payload);
      setNotification(success(`Reminder has been shared successfully !!`));
    } catch (error) {
      setNotification(warning(`Oops , error`));
      console.log('error', error);
    }
  };

  const giveAdminFeedBack = () => {
    setFeedbackBy(loggedInUser?.email as string);
    setNameFeedbackBy(loggedInUser?.lastName as string);
    setInvitationId(adminInvitationId);
    setIsAdminFeedback(true);
    setShowAddFeedback(false);
    setShowViewFeedback(false);
    setShowSurvey(true);
  };

  const showBackInterviewerList = () => {
    setShowTemplateList(false);
    setShowSurvey(false);
    setShowViewFeedback(false);
    setShowAddFeedback(true);
  };
  const onFinalFeedBackCancel = () => {
    setShowFinalFeedBack(false);
    setShowAddFeedback(true);
  };

  const onFinalFeedBackSaved = async (data: any, feedbackStatus: boolean) => {
    let editedNote = '';

    adminInvitationId = `${getJobId}_${candidiateId}_admin`;
    const efPayload = { ...evaluationFeedbackDTOHelper };
    efPayload.templateId = getTemplateId;
    efPayload.candidateId = candidiateId as string;
    efPayload.workAssignmentId = getTemplateId;
    efPayload.answeredBy = getFeedbackBy;
    efPayload.jobId = getJobId;
    efPayload.invitationId = getInvitationId;
    efPayload.name = getNameFeedbackBy;
    if (feedbackStatus) {
      efPayload.feedbackOption = data.type;
      efPayload.feedbackStag = data.stage;
      efPayload.feedbackStatus = data.status;
      efPayload.template = getSurveyFeedbackPayload;
    } else {
      efPayload.template = data;
    }

    if (isAdminFeedback) {
      efPayload.invitationId = adminInvitationId;
    }
    try {
      await createEvaluationdFeedback(efPayload);
      setNotification(success(`Feedback has been added successfully !!`));

      if (!isAdminFeedback) {
        const npayload = { ...interViewerNamePayloadHelper };
        npayload.inviteId = getInvitationId;
        npayload.email = getInterviwerEmail;
        npayload.feedbackGivenBy = getFeedbackBy;
        npayload.feedbackGivenByName = getNameFeedbackBy;
        await postEvaluatedLink(npayload);
      }

      if (feedbackStatus) {
        jobCandidateInteraction.id = candidiateData.id;
        jobCandidateInteraction.applicationStage = data.stage;
        jobCandidateInteraction.applicationState = data.status;
        jobCandidateInteraction.stageDate = data.stageDate;
        editedNote = `The Candidate Status has now been updated from <strong> 
                    ${candidiateData.applicationStage}  </strong> and <strong> 
                    ${candidiateData.applicationState}  </strong> to <strong> 
                    ${data.stage}  </strong> and <strong> 
                    ${data.status}  </strong>`;
        jobCandidateInteraction.candidateNotes = [
          {
            notes: editedNote,
            createdBy: getNameFeedbackBy ?? '',
            createdAt: formattedDateISO(new Date()),
          },
        ];
        jobCandidateInteraction.stageAndStateActions = [
          {
            stage: data.stage,
            state: data.status,
            id: '',
            updatedBy: getNameFeedbackBy ?? '',
            updatedOn: formattedDateISO(new Date()),
          },
        ];
        await updateCandidateSubmission([jobCandidateInteraction]);
        // await updateJobCandidateNotesStateStage(jobCandidateInteraction);
      }
      showSharedInterviwerList(getTemplateIndex, '', '');
      setShowFinalFeedBack(false);
      setShowAddFeedback(true);
    } catch (error: any) {
      setNotification(warning(`Oops , Template's Feedback already exists`));
      console.log('error', error);
    }
  };

  const submitFeedback = async (data: any) => {
    setSurveyFeedbackPayload(data);
    setShowSurvey(false);
    setShowViewFeedback(false);
    setShowTemplateList(false);

    if (Object.keys(associatedJsonObject).length > 0) {
      setShowFinalFeedBack(true);
    } else {
      onFinalFeedBackSaved(data, false);
    }
  };

  const showSharedInterviwerList = async (index: number, eventData: any, jobId: string) => {
    let templateListData, jobIdTemplateList;
    if (evaluationData.length > 0) {
      templateListData = evaluationData;
      jobIdTemplateList = getJobId;
    } else {
      templateListData = eventData;
      jobIdTemplateList = jobId;
    }
    adminInvitationId = `${jobIdTemplateList}_${candidiateId}_admin`;
    setAdminInvitationId(adminInvitationId);
    setTemplateIndex(index);
    const payload = { ...interViewerPayloadHelper };
    payload.evalTemplateId = templateListData[index].templateId as string;
    payload.interactionId = candidiateId as string;
    payload.jobId = jobIdTemplateList;
    let tempRes: any;
    try {
      const response = await postEvaluationTemplateList(payload);
      const interviewData = response.data;
      setInterviewList(interviewData);
      tempRes = await getEvaluationTemplateById(templateListData[index].templateId as string);
      const adminFeedBack = await getEvaluationResponseByInvitationId(adminInvitationId);
      if (adminFeedBack.data) {
        setAdminGivenFeedback(true);
        setAdminFeedbackOn(adminFeedBack.data.answeredOn);
        setAdminFeedBy(adminFeedBack.data.answeredBy);
        setAdminFeedByName(adminFeedBack.data.name);
      }
    } catch (error) {
      console.log('error', error);
    }
    setTemplateId(templateListData[index].templateId as string);
    setTemplateJsonObject(JSON.parse(JSON.stringify(tempRes.data.template)));
    setAssociatedJsonObject(JSON.parse(JSON.stringify(tempRes.data.associateStageStatusData)));
    setShowTemplateList(false);
  };

  const handleShareEvaluation = () => {
    setShareCandidate(true);
  };

  return (
    <>
      {showSurvey && (
        <>
          <SurveyFeedComponent
            surveyJson={templateJsonObject}
            feedbackDataBack={submitFeedback}
            callShowBackInterviewerList={showBackInterviewerList}
          />
        </>
      )}
      {showFinalFeedBack && (
        <>
          <AddEditAssociate
            associateJson={associatedJsonObject}
            onSave={onFinalFeedBackSaved}
            onCancel={onFinalFeedBackCancel}
          />
        </>
      )}
      {showViewFeedback && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 2, marginTop: 2 }}>
            <WsButton variant="outlined" size="small" onClick={() => showBackInterviewerList()}>
              Evaluators List
            </WsButton>
          </Box>
          <>
            <SubmissionCandidateEvalutationView feedbackResponseData={getFeedbackData} />
          </>
        </>
      )}
      {showAddFeedback && (
        <>
          {showTemplateList ? (
            <>
              {evaluationData ? (
                <>
                  {evaluationData.map((evalData, index: number) => (
                    <>
                      <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5, mt: 3 }}>
                        <Grid container alignItems="flex-start" justifyContent="space-between">
                          <Grid item>
                            <WsTypography variant={WsTypoVariants.SUB_TITLE}>
                              {evalData.templateName}
                            </WsTypography>
                            <Stack
                              direction="row"
                              px="11px"
                              sx={{ opacity: '65%', mt: 1 }}
                              spacing={2}
                            >
                              <WsIconText
                                textCursor="pointer"
                                popOverText="Evaluation tagged on"
                                icon={<CalendarMonthOutlinedIcon sx={{ fontSize: '20px' }} />}
                                text={getDateUsingFormat(evalData.createdOn as string, 'DD-MMM-YY')}
                                textSize={WsTypoVariants.BODY1}
                              />
                              <WsIconText
                                textCursor="pointer"
                                popOverText="Evaluation tagged by"
                                icon={<WorkOutlineIcon sx={{ fontSize: '20px' }} />}
                                text={` ${evalData.recruiterName as string} (${
                                  evalData.createdBy ?? ''
                                })`}
                                textSize={WsTypoVariants.BODY1}
                              />
                            </Stack>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            sx={{ display: 'flex', justifyContent: 'flex-end' }}
                          >
                            <WsButton
                              size="small"
                              onClick={() => showSharedInterviwerList(index, '', '')}
                            >
                              Show Evaluators
                            </WsButton>
                          </Grid>
                        </Grid>
                      </Paper>
                    </>
                  ))}
                </>
              ) : (
                <>
                  <p> No Template found with the Job</p>
                </>
              )}
            </>
          ) : (
            <>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginBottom: 2,
                  marginTop: 2,
                }}
              >
                <WsButton
                  variant="outlined"
                  size="medium"
                  onClick={() => setShowTemplateList(true)}
                >
                  Back to Evaluation
                </WsButton>
                {!isAdminGivenFeedback && (
                  <Box sx={{ marginLeft: '10px' }}>
                    <WsButton size="medium" onClick={() => giveAdminFeedBack()}>
                      Add recruiter feedback
                    </WsButton>
                  </Box>
                )}
              </Box>
              {isAdminGivenFeedback && (
                <>
                  <Box fontWeight="bold">
                    <WsTypography>Recruiter feedback response</WsTypography>
                  </Box>
                  <Paper variant="outlined" sx={{ borderRadius: 2, p: 2, marginTop: 2 }}>
                    <Grid item xs={12} spacing={2} mt={1}>
                      <Box borderRadius={1.5}>
                        <GridItem>
                          <Grid container sx={{ mt: 0.3 }}>
                            <Grid md={12} p={0.5} display="flex">
                              <Grid md={4}>
                                <WsTypography color={WsTypoColors.SECONDARY}>
                                  Feedback Given By :
                                </WsTypography>
                              </Grid>
                              <Grid md={8}>
                                <WsTypography>{`${adminFeedByName}(${adminFeedBy})`}</WsTypography>
                              </Grid>
                            </Grid>
                            <Grid md={12} p={0.5} display="flex">
                              <Grid md={4}>
                                <WsTypography color={WsTypoColors.SECONDARY}>
                                  Feedback Submitted On :
                                </WsTypography>
                              </Grid>
                              <Grid md={8}>
                                <WsTypography>
                                  {getDateUsingFormat(adminFeedbackOn, 'DD-MMM-YY')}
                                </WsTypography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Stack direction="row" spacing={0.7} justifyContent="end">
                              <WsButton
                                size="small"
                                onClick={() => viewFeedBack(getAdminInvitationId)}
                              >
                                View Feedback
                              </WsButton>
                            </Stack>
                          </Grid>
                        </GridItem>
                      </Box>
                    </Grid>
                  </Paper>
                </>
              )}
              {getInterviewList.length > 0 ? (
                <>
                  <Box mt={2} fontWeight="bold">
                    <WsTypography>{'Interviewer Feedback List'}</WsTypography>
                  </Box>
                  {getInterviewList.map((evalList, index: number) => (
                    <>
                      <Paper variant="outlined" sx={{ borderRadius: 2, p: 2, marginTop: 2 }}>
                        <Grid item xs={12} spacing={2} mt={1}>
                          <Box borderRadius={1.5}>
                            <GridItem>
                              <Grid container sx={{ mt: 0.3 }}>
                                <Grid md={12} p={0.5} display="flex">
                                  <Grid md={4}>
                                    <WsTypography color={WsTypoColors.SECONDARY}>
                                      Template Shared With :
                                    </WsTypography>
                                  </Grid>
                                  <Grid md={8}>
                                    <WsTypography>{`${evalList.name}(${evalList.email})`}</WsTypography>
                                  </Grid>
                                </Grid>
                                <Grid md={12} p={0.5} display="flex">
                                  <Grid md={4}>
                                    <WsTypography color={WsTypoColors.SECONDARY}>
                                      Template Shared On :
                                    </WsTypography>
                                  </Grid>
                                  <Grid md={8}>
                                    <WsTypography>
                                      {getDateUsingFormat(evalList.createdOn, 'DD-MMM-YY')}
                                    </WsTypography>
                                  </Grid>
                                </Grid>
                                {evalList.hasEvaluated && (
                                  <>
                                    <Grid md={12} p={0.5} display="flex">
                                      <Grid md={4}>
                                        <WsTypography color={WsTypoColors.SECONDARY}>
                                          Evaluation Given By :
                                        </WsTypography>
                                      </Grid>
                                      <Grid md={8}>
                                        <WsTypography>{`${evalList.feedbackGivenByName}(${evalList.feedbackGivenBy})`}</WsTypography>
                                      </Grid>
                                    </Grid>
                                    <Grid md={12} p={0.5} display="flex">
                                      <Grid md={4}>
                                        <WsTypography color={WsTypoColors.SECONDARY}>
                                          Evaluation Submitted On :
                                        </WsTypography>
                                      </Grid>
                                      <Grid md={8}>
                                        <WsTypography>
                                          {getDateUsingFormat(evalList.updatedOn, 'DD-MMM-YY')}
                                        </WsTypography>{' '}
                                      </Grid>
                                    </Grid>
                                  </>
                                )}
                              </Grid>
                              <Grid item xs={12}>
                                {evalList.hasEvaluated ? (
                                  <Stack direction="row" spacing={0.7} justifyContent="end">
                                    <WsButton
                                      size="small"
                                      onClick={() => viewFeedBack(evalList.inviteId)}
                                    >
                                      View Feedback
                                    </WsButton>
                                  </Stack>
                                ) : (
                                  <Grid>
                                    <Stack direction="row" spacing={0.7} justifyContent="end">
                                      <WsButton
                                        variant="outlined"
                                        size="small"
                                        onClick={() => callSendReminder(evalList.email)}
                                      >
                                        Send Reminder
                                      </WsButton>
                                      <WsButton size="small" onClick={() => giveFeedBack(index)}>
                                        Add Feedback
                                      </WsButton>
                                    </Stack>{' '}
                                  </Grid>
                                )}
                              </Grid>
                            </GridItem>
                          </Box>
                        </Grid>
                      </Paper>
                    </>
                  ))}
                </>
              ) : (
                <>
                  <Grid item xs={12} display="flex" justifyContent="center" pt={12}>
                    <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.SECONDARY}>
                      No Shared Interview Record found
                    </WsTypography>
                  </Grid>
                  <Grid item xs={12} display="flex" justifyContent="center" pt={2}>
                    <Stack direction="row" spacing={3}>
                      {isAdminGivenFeedback ? null : (
                        <WsButton variant="outlined" size="small" onClick={handleShareEvaluation}>
                          Share Evaluation
                        </WsButton>
                      )}
                    </Stack>
                  </Grid>
                </>
              )}
            </>
          )}
        </>
      )}
      {shareCandidate && candidiateId && (
        <ShareCandidate
          interactionId={candidiateId}
          jobTitle={candidiateData?.mappedJobTitle ?? ''}
          jobCode={candidiateData.jobCode ?? ''}
          name={candidiateData?.name}
          onClose={() => {
            setShareCandidate(false);
          }}
          reset={() => {
            setShareCandidate(false);
            setTimeout(() => setShareCandidate(false), 600);
          }}
        />
      )}
    </>
  );
};

export default SubmissionCandidateReview;
